/**
 * Permate Configuration
 * API keys và settings cho Permate tracking
 */

export const permateConfig = {
  // API Key từ Permate
  apiKey: '2994b65f38b444a7a9414a998b12',

  // Base URLs - Actual Permate endpoints
  postbackUrl: 'https://pmcloud1.com/postback',
  trackingUrl: 'https://pmcloud1.com',
  pixelUrl: 'https://pmcloud1.com/pixel',

  // Default settings
  defaultConversionType: 'purchase',
  enableLogging: process.env.NODE_ENV === 'development',

  // Postback parameters
  advId: '197694',
  offerId: '2495',

  // Timeout settings
  requestTimeout: 5000, // 5 seconds

  // Retry settings
  maxRetries: 3,
  retryDelay: 1000, // 1 second
} as const;

export type PermateConfig = typeof permateConfig;
